(() => {
  const enhanceMobileStorefront = () => {
    document.querySelectorAll('a[href*="0123456789"]').forEach((link) => {
      if (link.textContent.includes('hello@driftroom.co.uk')) {
        link.setAttribute('href', 'mailto:hello@driftroom.co.uk');
        link.setAttribute('aria-label', 'Email Driftroom support');
      }
    });

    document.querySelectorAll('a').forEach((link) => {
      const label = (link.textContent || '').replace(/\s+/g, ' ').trim();

      if (/^NEW:\s*Gifts$/i.test(label) && (link.getAttribute('href') || '').trim() === '/') {
        link.setAttribute('href', '/collections/all-lifestyle-lighting-quirky-gifts-driftroom');
      }

      const accessibleLabel = link.getAttribute('aria-label') || link.getAttribute('title') || label;
      if (/^Follow on Tiktok$/i.test(accessibleLabel)) {
        const href = (link.getAttribute('href') || '').trim();
        if (/^www\.tiktok\.com\//i.test(href)) {
          link.setAttribute('href', 'https://' + href);
        }
      }

      if (/^Return Policy$/i.test(label) && /\/policies\/terms-of-service/.test(link.getAttribute('href') || '')) {
        link.setAttribute('href', '/policies/refund-policy');
      }
    });

    document.querySelectorAll('h2, h3, h4').forEach((heading) => {
      if ((heading.textContent || '').trim() === 'Infomation') {
        heading.textContent = 'Information';
      }
    });

    const menu = document.querySelector('.t4s-push-menu-btn');
    if (menu && !menu.getAttribute('aria-label')) menu.setAttribute('aria-label', 'Open menu');

    const search = document.querySelector('header a[href="/search"]');
    if (search && !search.getAttribute('aria-label')) search.setAttribute('aria-label', 'Search');

    const cart = document.querySelector('header a[href="/cart"]');
    if (cart && !cart.getAttribute('aria-label')) cart.setAttribute('aria-label', 'View cart');

    const account = document.querySelector('header a[href="/account"]');
    if (account && !account.getAttribute('aria-label')) account.setAttribute('aria-label', 'Account');

    document.querySelectorAll('.t4s-quantity-wrapper').forEach((wrapper) => {
      const buttons = wrapper.querySelectorAll('button');
      if (buttons[0] && !buttons[0].getAttribute('aria-label')) buttons[0].setAttribute('aria-label', 'Decrease quantity');
      if (buttons[1] && !buttons[1].getAttribute('aria-label')) buttons[1].setAttribute('aria-label', 'Increase quantity');
    });

    document.querySelectorAll('a[href*="/collections/mens-socks"] img[alt="Img"]').forEach((image) => {
      image.setAttribute('alt', "Men's socks collection");
    });

    if (document.body.classList.contains('template-product') && !document.getElementById('codex-product-reassurance')) {
      const buyButtons = document.querySelector('.t4s-product-form__buttons');
      if (buyButtons) {
        const reassurance = document.createElement('div');
        reassurance.id = 'codex-product-reassurance';
        reassurance.className = 'codex-product-reassurance';
        reassurance.innerHTML = '<span>Free UK delivery over £50</span> · <a href="/policies/refund-policy">30-day returns</a> · <span>Secure checkout</span>';
        buyButtons.insertAdjacentElement('afterend', reassurance);
      }
    }
  };

  const startEnhancements = () => {
    enhanceMobileStorefront();
    const observer = new MutationObserver(enhanceMobileStorefront);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => {
      enhanceMobileStorefront();
      observer.disconnect();
    }, 7000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startEnhancements, { once: true });
  } else {
    startEnhancements();
  }
})();